import React from "react";
import styled from "styled-components/macro";
import Loader from "ui/Loader";

const StyledWrapper = styled.section`
  display: flex;
  flex-flow: column;
  height: 100%;
`;

const StyledLoadingPlaceholder = styled.section`
  flex: 1;
  overflow: auto;
  display: flex;
  flex-flow: column;
  height: 100%;
`;

const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
`;

const FadedWrapper = styled.div`
  opacity: 0.3;
`;

export const LoadingPlaceholder: React.FC = ({ children }) => {
  return <LoadingContainer loading={true}>{children}</LoadingContainer>;
};

export const LoadingContainer: React.FC<{ loading?: boolean }> = ({
  loading = false,
  children,
}) => {
  return loading ? (
    <StyledWrapper>
      <StyledLoadingPlaceholder data-testid="LoadingContainer">
        <LoadingOverlay>
          <Loader />
        </LoadingOverlay>
        <FadedWrapper>{children}</FadedWrapper>
      </StyledLoadingPlaceholder>
    </StyledWrapper>
  ) : (
    <>{children}</>
  );
};

export default LoadingContainer;
